/**
 * Imports
 */
import * as React from 'react';

import { MerchantDetails } from '../components';

import { useParams } from 'react-router-dom';
import { BaseLayout } from 'features/navigation';
/**
 * Types
 */
type MerchantPageProps = {};
type ParamTypes = {
  id: string;
};

/**
 * LoginPage component
 */
const MerchantPage: React.FC<MerchantPageProps> = () => {
  console.log('merchant page loaded');

  const { id } = useParams<ParamTypes>();

  return (
    <BaseLayout>
      <MerchantDetails id={id} />
    </BaseLayout>
  );
};

/**
 * Exports
 */
export { MerchantPage };
